import Vue from 'vue';
import GeneralMixin from '@/modules/common/mixins/general.mixin';
import VueSignature from 'vue-signature-pad';
import VueSweetalert2 from 'vue-sweetalert2';
import * as Sentry from '@sentry/vue';

import MessageService from '@/modules/common/services/message.service';
import GuardMixin from './core/guards/guard.mixin';

import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.mixin(GuardMixin);
Vue.mixin(GeneralMixin);
Vue.mixin(MessageService);

Vue.use(VueSignature);
Vue.use(VueSweetalert2);

Sentry.init({
  Vue,
  dsn: 'https://627bf2e9af474ee68eb690fc70b9930d@o4511138744696832.ingest.de.sentry.io/4511393350352976',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
});

const vueApp = new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');

export default vueApp;
